export const QuestionPhase = Object.freeze({
    ACTIVITYSELECT:    'activity_select',
    PREQUESTIONS:      'pre_questions',
    LEGISLATIONS:      'legislations',
    SUBQUESTIONS:      'sub_questions',
    RESULTS:           'results'
})

export const ElementType = Object.freeze({
    STATEMENT:   'statement',
    REASON:      'reason',
    RESULT:      'result',
})

export const ResultType = Object.freeze({
    REQUIRED:      'Required',
    LEARN:         'Learn',
    NOTREQUIRED:   'Not Required',
})